'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = exports.carouselIndex = undefined;
var _systemComponents = require('system-components');
var _systemComponents2 = _interopRequireDefault(_systemComponents);
var _gridStyled = require('grid-styled');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var carouselIndex = exports.carouselIndex = function carouselIndex(_ref) {
  var index = _ref.index;
  return {
    '& > div:first-child': {
      marginLeft: index * -100 + '%',
      transitionProperty: 'margin',
      transitionDuration: '.2s',
      transitionTimingFunction: 'ease-out'
    }
  };
};
var Carousel = exports.Carousel = (0, _systemComponents2["default"])({
  is: _gridStyled.Flex,
  width: 1
}, {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  '& > div': {
    flex: 'none',
    width: '100%'
  }
}, carouselIndex, 'space', 'color');
Carousel.displayName = 'Carousel';
exports["default"] = Carousel;